function togglePasswordVisibility(passwordInputId, toggleBtnSelector, toggleBtnHiddenSelector) {
  const passwordInput = document.getElementById(passwordInputId);
  const eyeBtn = document.querySelector(toggleBtnSelector);
  const eyeSlashBtn = document.querySelector(toggleBtnHiddenSelector);

  if (passwordInput && eyeBtn && eyeSlashBtn) {
    if (passwordInput.type === 'password') {
      // Show password - hide eye icon, show eye-slash icon
      passwordInput.type = 'text';
      eyeBtn.style.display = 'none';
      eyeSlashBtn.style.display = 'block';
      eyeSlashBtn.setAttribute('aria-label', 'Hide password');
    } else {
      // Hide password - show eye icon, hide eye-slash icon
      passwordInput.type = 'password';
      eyeBtn.style.display = 'block';
      eyeSlashBtn.style.display = 'none';
      eyeBtn.setAttribute('aria-label', 'Show password');
    }
  }
}

function validatePassword(password) {
  // At least 12 characters long
  if (password.length < 12) {
    return false;
  }

  // Check for uppercase letters
  if (!/[A-Z]/.test(password)) {
    return false;
  }

  // Check for lowercase letters
  if (!/[a-z]/.test(password)) {
    return false;
  }

  // Check for numbers
  if (!/[0-9]/.test(password)) {
    return false;
  }

  // Check for symbols: ! . ? $ % ^ & ) _ -
  if (!/[!\.\?\$\%\^\&\)\_\-]/.test(password)) {
    return false;
  }

  return true;
}

function handlePasswordValidation(passwordInputId, passwordRequirementsSelector) {
  const passwordInput = document.getElementById(passwordInputId);
  const passwordRequirements = document.querySelector(passwordRequirementsSelector);
  const registerForm = passwordInput ? passwordInput.closest('form') : null;
  
  if (passwordInput && registerForm) {
    // Track if form has been submitted/attempted to show errors
    let formSubmitted = false;
    
    const updatePasswordRequirements = (isValid) => {
      if (passwordRequirements) {
        if (!isValid) {
          // Invalid password - show red
          passwordRequirements.classList.remove('text-brown1');
          passwordRequirements.classList.add('text-red1');
        } else {
          // Valid password - show brown
          passwordRequirements.classList.remove('text-red1');
          passwordRequirements.classList.add('text-brown1');
        }
      }
    };

    const showPasswordError = function() {
      const password = passwordInput.value.trim();
      if (password.length > 0) {
        const isValid = validatePassword(password);
        if (!isValid) {
          passwordInput.classList.add('wrong-data');
          updatePasswordRequirements(false);
          return true; // Error shown
        } else {
          passwordInput.classList.remove('wrong-data');
          updatePasswordRequirements(true);
        }
      }
      return false; // No error
    };

    // Check on page load if form was submitted (has errors) and password is invalid
    // This allows both Shopify errors and password errors to show together
    const checkPasswordOnLoad = function() {
      // Check if there are form errors (form was submitted)
      const hasFormErrors = registerForm.querySelector('.form__message, [class*="error"], .text-red1');
      if (hasFormErrors || document.querySelector('[class*="wrong-data"]')) {
        // Form was submitted, check password
        showPasswordError();
      }
    };

    // Validate on form submit and prevent submission if password is invalid
    registerForm.addEventListener('submit', function(e) {
      const password = passwordInput.value.trim();
      formSubmitted = true; // Mark that form submission was attempted
      
      if (password.length > 0) {
        const isValid = validatePassword(password);
        if (!isValid) {
          // Prevent form submission if password is invalid
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Show error immediately
          passwordInput.classList.add('wrong-data');
          updatePasswordRequirements(false);
          
          // Focus on password input to show the error
          passwordInput.focus();
          
          // Clear sessionStorage flag since we're not submitting
          sessionStorage.removeItem('passwordInvalid');
          
          return false;
        } else {
          // Password is valid, allow form to submit
          passwordInput.classList.remove('wrong-data');
          updatePasswordRequirements(true);
          // Clear sessionStorage flag since password is valid
          sessionStorage.removeItem('passwordInvalid');
        }
      } else {
        // If password is empty, let Shopify handle the validation
        sessionStorage.removeItem('passwordInvalid');
      }
    }, true); // Use capture phase to ensure we catch it first

    // Check password on page load (after form submission with errors)
    checkPasswordOnLoad();

    // Also check when password input value changes (in case it's pre-filled)
    if (passwordInput.value) {
      showPasswordError();
    }

    // Show/hide errors when user types (only after form submission attempt)
    passwordInput.addEventListener('input', function() {
      const password = this.value;
      const isValid = validatePassword(password);
      
      if (formSubmitted) {
        // Only show errors after form submission was attempted
        if (isValid) {
          this.classList.remove('wrong-data');
          updatePasswordRequirements(true);
          // Clear sessionStorage flag since password is now valid
          sessionStorage.removeItem('passwordInvalid');
        } else if (password.length > 0) {
          // Show error if password is invalid (after submit attempt)
          this.classList.add('wrong-data');
          updatePasswordRequirements(false);
        } else {
          // Remove error if password is empty
          this.classList.remove('wrong-data');
          updatePasswordRequirements(true);
        }
      }
    });
  }
}

function handleEmailErrorPadding(emailFieldSelector, emailInputId) {
  const emailField = document.querySelector(emailFieldSelector);
  const emailInput = document.getElementById(emailInputId);
  
  if (emailField && emailInput) {
    // Only check for the "email already exists" error message div, not the wrong-data class
    // The error message appears when form.errors contains 'form' (email already exists)
    // It's the next sibling div with classes 'text-red1', 'style-p5', and contains a link
    const errorMessageDiv = emailField.nextElementSibling;
    const hasEmailExistsError = errorMessageDiv && 
                                errorMessageDiv.classList.contains('text-red1') &&
                                errorMessageDiv.classList.contains('style-p5') &&
                                errorMessageDiv.querySelector('a') && // Check if it contains a link (the "here" link)
                                errorMessageDiv.style.display !== 'none'; // Only if the error message is visible
    
    if (hasEmailExistsError) {
      // Remove padding classes only when "email already exists" error is present and visible
      emailField.classList.remove('pb-lg', 'md:pb-2xl');
    } else {
      // Add padding classes back when no "email already exists" error or it's hidden
      emailField.classList.add('pb-lg', 'md:pb-2xl');
    }
  }
}

function handleFormToggle() {
  const toggleContainer = document.querySelector('.customer-register-toggle-container');
  const b2cForm = document.querySelector('.b2c_customer_form');
  const b2bForm = document.querySelector('.b2b_customer_form');

  if (!toggleContainer || !b2cForm || !b2bForm) return;

  // Restore active form on page load if there were errors
  const hasFormErrors = document.querySelector('.b2c-form .form__message, .b2b-form .form__message, [class*="error"], .text-red1');
  const savedFormType = sessionStorage.getItem('activeRegisterForm');
  
  if (hasFormErrors && savedFormType) {
    // Restore the form that was active when error occurred
    const allToggleItems = document.querySelectorAll('.customer-register-toggle-item');
    allToggleItems.forEach(toggle => toggle.classList.remove('active'));
    
    if (savedFormType === 'b2c') {
      document.querySelector('.b2c-toggle').classList.add('active');
      b2cForm.style.display = 'block';
      b2bForm.style.display = 'none';
      
      // Hide error messages in B2B form
      const b2bErrorMessages = b2bForm.querySelectorAll('.text-red1.style-p5');
      b2bErrorMessages.forEach(error => {
        if (error.textContent.includes('here') || error.querySelector('a')) {
          error.style.display = 'none';
        }
      });
      // Remove wrong-data class from B2B email input
      const b2bEmailInput = document.getElementById('RegisterForm-B2B-email');
      if (b2bEmailInput) {
        b2bEmailInput.classList.remove('wrong-data');
      }
      // Restore padding for B2B email field since error is hidden
      const b2bEmailField = document.querySelector('.field_customer_email_b2b');
      if (b2bEmailField) {
        b2bEmailField.classList.add('pb-lg', 'md:pb-2xl');
      }
    } else if (savedFormType === 'b2b') {
      document.querySelector('.b2b-toggle').classList.add('active');
      b2bForm.style.display = 'block';
      b2cForm.style.display = 'none';
      
      // Hide error messages in B2C form
      const b2cErrorMessages = b2cForm.querySelectorAll('.text-red1.style-p5');
      b2cErrorMessages.forEach(error => {
        if (error.textContent.includes('here') || error.querySelector('a')) {
          error.style.display = 'none';
        }
      });
      // Remove wrong-data class from B2C email input
      const b2cEmailInput = document.getElementById('RegisterForm-email');
      if (b2cEmailInput) {
        b2cEmailInput.classList.remove('wrong-data');
      }
      // Restore padding for B2C email field since error is hidden
      const b2cEmailField = document.querySelector('.field_customer_email');
      if (b2cEmailField) {
        b2cEmailField.classList.add('pb-lg', 'md:pb-2xl');
      }
    }
  }

  // Use event delegation to handle clicks on toggle items and their children
  toggleContainer.addEventListener('click', function(e) {
    // Find the closest toggle item (handles clicks on child elements like span)
    const clickedToggle = e.target.closest('.customer-register-toggle-item');
    
    if (!clickedToggle) return;
    
    const formType = clickedToggle.getAttribute('data-form');
    const allToggleItems = document.querySelectorAll('.customer-register-toggle-item');
    
    // Remove active class from all toggle items
    allToggleItems.forEach(toggle => toggle.classList.remove('active'));
    
    // Add active class to clicked toggle item
    clickedToggle.classList.add('active');
    
    // Hide both forms
    b2cForm.style.display = 'none';
    b2bForm.style.display = 'none';
    
    // Show the selected form
    if (formType === 'b2c') {
      b2cForm.style.display = 'block';
    } else if (formType === 'b2b') {
      b2bForm.style.display = 'block';
    }
    
    // Store the active form type
    sessionStorage.setItem('activeRegisterForm', formType);
  });
}

function validateRequiredFields(formSelector) {
  const form = document.querySelector(formSelector);
  if (!form) return false;

  let hasErrors = false;
  const requiredFields = form.querySelectorAll('input[required], input[aria-required="true"]');
  
  requiredFields.forEach(field => {
    const value = field.value.trim();
    const isEmpty = value === '';
    
    // For password fields, only validate if empty (password strength validation is separate)
    // Password strength validation handles wrong-data for non-empty invalid passwords
    if (field.id === 'RegisterForm-B2B-password' || field.id === 'RegisterForm-password') {
      if (isEmpty) {
        // Only add wrong-data if password is actually empty
        field.classList.add('wrong-data');
        hasErrors = true;
      }
      // Don't remove wrong-data if password has content - let password strength validation handle it
      // This prevents us from removing wrong-data that was added by password strength validation
      return;
    }
    
    if (isEmpty) {
      field.classList.add('wrong-data');
      hasErrors = true;
    } else {
      field.classList.remove('wrong-data');
    }
  });

  // Special handling for business type selector (hidden input)
  const businessTypeInput = form.querySelector('#RegisterForm-B2B-BusinessAddress[type="hidden"]');
  if (businessTypeInput) {
    const businessSelector = businessTypeInput.closest('.business-selector');
    if (businessTypeInput.value.trim() === '') {
      if (businessSelector) {
        businessSelector.classList.add('wrong-data');
      }
      businessTypeInput.classList.add('wrong-data');
      hasErrors = true;
    } else {
      if (businessSelector) {
        businessSelector.classList.remove('wrong-data');
      }
      businessTypeInput.classList.remove('wrong-data');
    }
  }

  return !hasErrors;
}

function initBusinessSelector() {
  const businessSelectors = document.querySelectorAll('.business-selector');
  
  if (!businessSelectors.length) return;

  businessSelectors.forEach(selector => {
    const trigger = selector.querySelector('.business-select-trigger');
    const dropdown = selector.querySelector('.business-select-dropdown');
    const selectText = selector.querySelector('.business-select-text');
    const optionItems = selector.querySelectorAll('.business-option-item');

    if (!trigger || !dropdown) return;

    // Toggle dropdown on selector click (anywhere on the selector)
    selector.addEventListener('click', function(e) {
      // Don't toggle if clicking inside the dropdown
      if (dropdown.contains(e.target)) {
        return;
      }
      selector.classList.toggle('active');
    });

    // Handle option selection (like a select)
    optionItems.forEach(optionItem => {
      optionItem.addEventListener('click', function(e) {
        e.stopPropagation();
        
        const optionLabel = optionItem.querySelector('.business-option-label');
        const selectedValue = optionLabel.getAttribute('data-value') || optionLabel.textContent.trim();
        
        // Get the hidden input field for business address
        const businessInput = selector.closest('.field').querySelector('input[type="hidden"]');
        
        // Remove active class from all options
        optionItems.forEach(item => {
          item.classList.remove('active');
        });
        
        // Add active class to clicked option
        optionItem.classList.add('active');
        
        // Update display text
        selectText.textContent = selectedValue;
        
        // Update hidden input value for form submission
        if (businessInput) {
          businessInput.value = selectedValue;
          // Remove error class when selection is made
          businessInput.classList.remove('wrong-data');
          selector.classList.remove('wrong-data');
        }
        
        // Close dropdown after selection
        selector.classList.remove('active');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!selector.contains(e.target)) {
        selector.classList.remove('active');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Handle form toggle
  handleFormToggle();
  
  // Initialize business selector
  initBusinessSelector();

  // Handle password visibility toggle for B2C form
  const eyeToggleBtn = document.querySelector('.eye-toggle-btn');
  const eyeToggleBtnHidden = document.querySelector('.eye-toggle-btn-hidden');
  const eyeToggleBtnB2B = document.querySelector('.eye-toggle-btn-b2b');
  const eyeToggleBtnB2BHidden = document.querySelector('.eye-toggle-btn-b2b-hidden');

  if (eyeToggleBtn) {
    eyeToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-password', '.eye-toggle-btn', '.eye-toggle-btn-hidden');
    });
    eyeToggleBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-password', '.eye-toggle-btn', '.eye-toggle-btn-hidden');
    });
  }

  if (eyeToggleBtnHidden) {
    eyeToggleBtnHidden.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-password', '.eye-toggle-btn', '.eye-toggle-btn-hidden');
    });
    eyeToggleBtnHidden.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-password', '.eye-toggle-btn', '.eye-toggle-btn-hidden');
    });
  }

  if (eyeToggleBtnB2B) {
    eyeToggleBtnB2B.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-B2B-password', '.eye-toggle-btn-b2b', '.eye-toggle-btn-b2b-hidden');
    });
    eyeToggleBtnB2B.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-B2B-password', '.eye-toggle-btn-b2b', '.eye-toggle-btn-b2b-hidden');
    });
  }

  if (eyeToggleBtnB2BHidden) {
    eyeToggleBtnB2BHidden.addEventListener('click', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-B2B-password', '.eye-toggle-btn-b2b', '.eye-toggle-btn-b2b-hidden');
    });
    eyeToggleBtnB2BHidden.addEventListener('touchend', function(e) {
      e.preventDefault();
      togglePasswordVisibility('RegisterForm-B2B-password', '.eye-toggle-btn-b2b', '.eye-toggle-btn-b2b-hidden');
    });
  }

  // Handle password validation for both forms
  handlePasswordValidation('RegisterForm-password', '.password-requirements');
  handlePasswordValidation('RegisterForm-B2B-password', '.password-requirements-b2b');

  // Handle required field validation for B2B form
  const b2bForm = document.querySelector('.b2b-form');
  if (b2bForm) {
    // Store active form type on submit
    b2bForm.addEventListener('submit', function() {
      sessionStorage.setItem('activeRegisterForm', 'b2b');
    });

    // Remove error class when user starts typing
    const requiredInputs = b2bForm.querySelectorAll('input[required], input[aria-required="true"]');
    requiredInputs.forEach(input => {
      input.addEventListener('input', function() {
        if (this.value.trim() !== '') {
          this.classList.remove('wrong-data');
          // Also remove from business selector if applicable
          if (this.id === 'RegisterForm-B2B-BusinessAddress') {
            const businessSelector = this.closest('.business-selector');
            if (businessSelector) {
              businessSelector.classList.remove('wrong-data');
            }
          }
        }
      });
    });

    // Validate on form submit
    b2bForm.addEventListener('submit', function(e) {
      const isPasswordValid = !document.getElementById('RegisterForm-B2B-password')?.classList.contains('wrong-data');
      const areFieldsValid = validateRequiredFields('.b2b-form');
      
      if (!areFieldsValid || !isPasswordValid) {
        e.preventDefault();
        e.stopPropagation();
        
        // Focus on first invalid field
        const firstError = b2bForm.querySelector('.wrong-data');
        if (firstError && firstError.focus) {
          firstError.focus();
        }
        
        return false;
      }
    }, true); // Use capture phase
  }

  // Handle required field validation for B2C form
  const b2cForm = document.querySelector('.b2c-form');
  if (b2cForm) {
    // Store active form type on submit
    b2cForm.addEventListener('submit', function() {
      sessionStorage.setItem('activeRegisterForm', 'b2c');
    });

    // Remove error class when user starts typing
    const requiredInputs = b2cForm.querySelectorAll('input[required], input[aria-required="true"]');
    requiredInputs.forEach(input => {
      input.addEventListener('input', function() {
        if (this.value.trim() !== '') {
          this.classList.remove('wrong-data');
        }
      });
    });

    // Validate on form submit
    b2cForm.addEventListener('submit', function(e) {
      // Validate required fields (this will add wrong-data to empty fields including password if empty)
      const areFieldsValid = validateRequiredFields('.b2c-form');
      
      // Check if any field has wrong-data (including password if it's empty or invalid)
      const hasErrors = b2cForm.querySelector('.wrong-data');
      
      if (!areFieldsValid || hasErrors) {
        e.preventDefault();
        e.stopPropagation();
        
        // Focus on first invalid field
        const firstError = b2cForm.querySelector('.wrong-data');
        if (firstError && firstError.focus) {
          firstError.focus();
        }
        
        return false;
      }
    }, true); // Use capture phase
  }

  // Sync VAT number from tax_id field to notes field as backup
  const vatNumberInput = document.getElementById('RegisterForm-B2B-VatNumber');
  const vatNumberNotes = document.getElementById('RegisterForm-B2B-VatNumber-Notes');
  if (vatNumberInput && vatNumberNotes) {
    // Sync on input
    vatNumberInput.addEventListener('input', function() {
      vatNumberNotes.value = this.value;
    });
    // Sync on page load if value exists
    if (vatNumberInput.value) {
      vatNumberNotes.value = vatNumberInput.value;
    }
    // Sync on form submit
    if (b2bForm) {
      b2bForm.addEventListener('submit', function() {
        vatNumberNotes.value = vatNumberInput.value;
      });
    }
  }
  
  // Check and handle email error padding on page load for B2C form
  handleEmailErrorPadding('.field_customer_email', 'RegisterForm-email');
  
  // Watch for changes to email error state for B2C form
  const emailInput = document.getElementById('RegisterForm-email');
  const emailField = document.querySelector('.field_customer_email');
  
  if (emailInput && emailField) {
    // Use MutationObserver to watch for class changes on email input
    const inputObserver = new MutationObserver(function() {
      handleEmailErrorPadding('.field_customer_email', 'RegisterForm-email');
    });
    
    inputObserver.observe(emailInput, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also watch for error message div appearing/disappearing after email field
    const formContainer = emailField.closest('form') || emailField.parentElement;
    if (formContainer) {
      const containerObserver = new MutationObserver(function() {
        handleEmailErrorPadding('.field_customer_email', 'RegisterForm-email');
      });
      
      containerObserver.observe(formContainer, {
        childList: true,
        subtree: false
      });
    }
  }

  // Check and handle email error padding on page load for B2B form
  handleEmailErrorPadding('.field_customer_email_b2b', 'RegisterForm-B2B-email');
  
  // Watch for changes to email error state for B2B form
  const emailInputB2B = document.getElementById('RegisterForm-B2B-email');
  const emailFieldB2B = document.querySelector('.field_customer_email_b2b');
  
  if (emailInputB2B && emailFieldB2B) {
    // Use MutationObserver to watch for class changes on email input
    const inputObserverB2B = new MutationObserver(function() {
      handleEmailErrorPadding('.field_customer_email_b2b', 'RegisterForm-B2B-email');
    });
    
    inputObserverB2B.observe(emailInputB2B, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also watch for error message div appearing/disappearing after email field
    const formContainerB2B = emailFieldB2B.closest('form') || emailFieldB2B.parentElement;
    if (formContainerB2B) {
      const containerObserverB2B = new MutationObserver(function() {
        handleEmailErrorPadding('.field_customer_email_b2b', 'RegisterForm-B2B-email');
      });
      
      containerObserverB2B.observe(formContainerB2B, {
        childList: true,
        subtree: false
      });
    }
  }
});
